import "./JsonTree.moduleRenamed.css";

export const jsonTree = "JsonTree-module__jsonTree___3N3qs";
export const jsonTreeTitle = "JsonTree-module__jsonTreeTitle___xoUKO";
export const jsonTreeTitleStr = "JsonTree-module__jsonTreeTitleStr___-kTM2";

export default {
  jsonTree: "JsonTree-module__jsonTree___3N3qs",
  jsonTreeTitle: "JsonTree-module__jsonTreeTitle___xoUKO",
  jsonTreeTitleStr: "JsonTree-module__jsonTreeTitleStr___-kTM2",
};